<template>
  <table>
    <tbody>
      <tr>
        <!-- <td>
          <div class="headPicture">
            <slot name="picture"></slot>
          </div>
        </td> -->
      </tr>
      <tr>
        <td>
          <p class="content">
            <slot name="content"></slot>
          </p>
        </td>
      </tr>
      <tr>
        <td>
          <p class="english">
            <slot name="english"></slot>
          </p>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {}
</script>

<style lang="less" scoped>
table {
  margin: 0.45rem 0.2rem;
}
tbody td {
  text-align: center;
}
// .headPicture {
//   margin: 0 auto;
//   width: 1.7rem;
//   height: 1.7rem;
//   background: #acacac;
//   box-shadow: 0px 12px 18px 0px rgba(47, 47, 51, 0.16);
//   border-radius: 50%;
//   border: 0.05rem solid #ffffff;
//   overflow: hidden;
// }
// .headPicture img {
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
// }
.content {
  height: 0.22rem;
  font-family: "Microsoft YaHei";
  font-weight: bold;
  font-size: 0.17rem;
  color: #1d78a6;
  line-height: 0.23rem;
  margin-top: 0.25rem;
  max-width: 3.4rem;
  //   text-align: center;
}
.english {
  height: 0.15rem;
  font-family: Myriad Pro;
  font-weight: 400;
  font-size: 0.1rem;
  color: #696969;
  line-height: 0.23rem;
  max-width: 1.9rem;
  margin: 0 0.3rem;
  margin-top: 0.01rem;
  // width: 3rem;
  //   text-align: center;
}
</style>
